module.exports = __webpack_public_path__ + "img/main.db15acc0.webp";